export default __webpack_public_path__ + "static/media/ai-defi-arbitrage.7437c8c2.png";